import RfiPieChart from './RfiPieChart.component';

export default RfiPieChart;